import React from 'react'

export default function PageLoader() {
    return (
        <div className="flex justify-center items-center py-20 flex-auto">
            <div className="loaderBox" style={{ position: 'unset', margin: 0, padding: 0, height: 'unset', width: 'unset' }}>
                <div className="relative flex items-center justify-center">

                    {/* Outer glow ring */}
                    <div className="absolute w-16 h-16 rounded-full bg-[#AF0056]/20 blur-xl animate-pulse"></div>

                    {/* Spinner */}
                    <div className="w-10 h-10 rounded-full border-4 border-transparent border-t-[#AF0056] border-r-pink-400 animate-spin"></div>

                </div>
            </div>
        </div>
    )
}
